import { createIconComponent } from '../../factory/create-icon-component';
export const CanadaIcon = createIconComponent(
  'CanadaIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_10086_33074)">
      <path d="M23 4.99994H1V19.9995H23V4.99994Z" fill="#F0F0F0" />
      <path d="M8.33316 4.99994H1V19.9999H8.33316V4.99994Z" fill="#D80027" />
      <path
        d="M22.9998 4.99994H15.6667V19.9999H22.9998V4.99994Z"
        fill="#D80027"
      />
      <path
        d="M13.375 13.5416L14.75 12.8385L14.0625 12.487V11.7838L12.6875 12.487L13.375 11.0807H12.6875L12 10.026L11.3125 11.0807H10.625L11.3125 12.487L9.9375 11.7838V12.487L9.25 12.8385L10.625 13.5416L10.2813 14.2447H11.6563V15.2994H12.3438V14.2447H13.7188L13.375 13.5416Z"
        fill="#D80027"
      />
    </g>
    <defs>
      <clipPath id="clip0_10086_33074">
        <rect x="1" y="5" width="22" height="15" rx="2" fill="white" />
      </clipPath>
    </defs>
  </svg>,
  'flag',
);
